import React from "react";
import { Tag } from "@jsq/ds/core";

export type SelectedTagProps = {
  /**
   * The label to display in the tag
   */
  label: string;
  /**
   * Callback when the remove button is clicked
   */
  onRemove: () => void;
  /**
   * Test ID for the component
   */
  testId?: string;
};

/**
 * A simple tag component for displaying selected items with a remove button
 */
export const SelectedTag: React.FC<SelectedTagProps> = ({ label, onRemove, testId }) => {
  return <Tag label={label} onRemove={onRemove} data-testid={testId} />;
};
